import styled from "styled-components";

export const StyledUnorderedListInt = styled.ul<{
  equalLabelWidth?: boolean;
  minColumnWidth?: string;
}>`
  list-style-type: none;
  padding-left: 0;
  max-width: 100%;
  padding-bottom: 10px;

  ${props =>
    props.minColumnWidth &&
    `
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(${props.minColumnWidth}, 1fr));
  gap: 16px 24px;
  align-items: start;
  & > li {
    margin-bottom: 0;
  }
  `}

  ${props =>
    !props.minColumnWidth &&
    props.equalLabelWidth &&
    `
  display: table;
  & > li {
    display: table-row;
    & > * {
      display: table-cell;
      &:first-of-type {
        padding-right: 8px;
      }
    }
  }
  `}
`;

export const StyledPagesLandingPageListItem = styled.li`
  list-style-type: none;
  display: flex;
  align-items: center;
  margin-bottom: 0.8rem;
`;

export const StyledUnorderedListHeader = styled.h4`
  margin: 0;
  padding: 0;
  font-size: 1.2rem;
  font-weight: 500;
  color: #000;
  margin-top: 8px;
`;

export interface StyledUnorderedListProps {
  children?: React.ReactNode;
  equalLabelWidth?: boolean;
  /**
   * Flow items into a fluid responsive grid instead of a single column, with
   * this as each column's minimum width (e.g. "180px"). Column count is chosen
   * by `auto-fit` from the available width, so no breakpoints are involved.
   * Takes precedence over `equalLabelWidth`, whose table layout conflicts.
   */
  minColumnWidth?: string;
}
export const StyledUnorderedList = ({
  children,
  equalLabelWidth,
  minColumnWidth
}: StyledUnorderedListProps) => {
  return (
    <StyledUnorderedListInt
      equalLabelWidth={equalLabelWidth}
      minColumnWidth={minColumnWidth}
    >
      {children}
    </StyledUnorderedListInt>
  );
};
